import { render, staticRenderFns } from "./UserResellerMap.vue?vue&type=template&id=168d0db7"
import script from "./UserResellerMap.vue?vue&type=script&lang=js"
export * from "./UserResellerMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports